module.exports = __webpack_public_path__ + "img/user.19ff9ef2.svg";